<script>
	import { Link } from 'svelte-routing';
	import ProductCard from './ProductCard.svelte';
	import { productStore } from '../../stores/products.store';
</script>

<section class="section new-arrival">
	<div class="title">
		<h1>NEW ARRIVALS</h1>
		<p>All the latest picked from our store</p>
	</div>

	<div class="product-center">
		{#each $productStore.slice(5, 9) || [] as item}
			<ProductCard {item} />
		{/each}
	</div>
</section>
